import { useLocation } from "@tanstack/react-router";

const isPresent = (value: unknown) => value !== undefined && value !== null;
const hasValue = (value: unknown) => isPresent(value) && value !== "";

export const useShouldSetAppUI = () => {
  const location = useLocation();
  const search = location.search as Record<string, unknown>;

  const openedByApp = isPresent(search.webview) || hasValue(search.flowId);

  return location.pathname === "/app-webview" && openedByApp;
};
